import { defineComponent as _defineComponent } from 'vue'
import { PropType, ref, watch } from 'vue';
import { TranslateResult } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'FeedbackRatingSelect',
  props: {
    label: { type: [String, Object] as PropType<string|TranslateResult>, required: false, default: '' },
    width: { type: Number as PropType<Number>, required: true, default: 110 },
    value: { type: Object as PropType<Array<number>>, required: true },
  },
  emits: ['input'],
  setup(__props, { emit }) {

const props = __props;





const items = [1, 2, 3, 4, 5];

const ratings = ref(props.value);

const clear = () => { ratings.value = items; emit('input', ratings.value); };

watch(() => props.value, () => { ratings.value = props.value; });

const ratingsChanged = () => {
  if (ratings.value.length === 0) {
    ratings.value = items;
  }
  ratings.value = ratings.value.sort((n1, n2) => n1 - n2);
  emit('input', ratings.value);
};


return { __sfc: true,props, emit, items, ratings, clear, ratingsChanged }
}

})